import { useParams } from "react-router"
import { createDraftId } from "authoring/routes/project/lib/project-utils"

export function useScheduleEditorIds() {
    const { projectId, scheduleId } = useParams()

    return {
        projectId,
        scheduleId,
        draftId: createDraftId(projectId, scheduleId),
    }
}
